import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { trackFunderProfileProgramClick } from 'utils/mixpanel'

const FunderPrograms = ({ funderPrograms, programIndex, setProgramIndex }) => {
  const onProgramIndexChange = newIndex => {
    setProgramIndex(newIndex)
    trackFunderProfileProgramClick(funderPrograms[newIndex].id)
  }

  return (
    <Tabs className="vertical-tabs" selectedIndex={programIndex} onSelect={onProgramIndexChange}>
      <TabList>
        {funderPrograms.map((program, index) => (
          <Tab key={index}>{program.name}</Tab>
        ))}
      </TabList>
      {funderPrograms.map((_, index) => (
        <TabPanel key={index} className="tw-hidden" />
      ))}
    </Tabs>
  )
}

export default FunderPrograms
